exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement {\n  height: 100%;\n  background-color: #FCFCFC;\n  font-size: 0.28rem;\n  padding: 0.2rem;\n  line-height: 0.52rem;\n  color: #333333;\n}\n.agreement h1 {\n  text-align: center;\n  font-size: 0.32rem;\n  font-weight: bold;\n}\n.agreement h2 {\n  font-weight: bold;\n}\n.agreement ul {\n  list-style: none;\n  padding-left: 0.48rem;\n}\n.agreement a {\n  color: #6FB7FF;\n  word-break: break-all;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/teamsofservice_ios/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/teamsofservice_ios/index.less
// module chunks = 0